import { useNavigate } from "@tanstack/react-router";
import { Button } from "@/components/common";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-subtle px-4">
      <p className="mb-2 text-sm font-medium tracking-widest text-adara-500 uppercase">
        Błąd
      </p>

      <h1 className="mb-3 text-7xl font-bold text-adara-900">404</h1>

      <p className="mb-8 max-w-md text-center text-dim">
        Strona, której szukasz, nie istnieje lub została przeniesiona.
      </p>

      <div className="flex gap-3">
        <Button
          variant="primary"
          onClick={() => {
            void navigate({ to: "/" });
          }}
        >
          Strona główna
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            window.history.back();
          }}
        >
          Wróć
        </Button>
      </div>

      <div className="mt-12">
        <img
          src="/logos/adara-logo.svg"
          alt="Adara"
          className="h-8 opacity-30"
        />
      </div>
    </div>
  );
}
